import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner'

import { ValidatorUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, InstantActions, ToastActions } from '../../actions';
import { TitleBar, NavBar, Header, Input, PhoneInput, AuthCheck } from  '../../components'

class InstantSettingsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      confirm_email: '',
      password: '',
      confirm_password: '',
      practice_name: '',
      street_address: '',
      phone_number: '',
      city: '',
      state: '',
      zipcode: '',
      display_edit_email: false,
      display_edit_password: false,
      display_edit_practice: false,
      email_invalid: false,
      confirm_email_invalid: false,
      display_password_rules: false,
      lodaing_practice: false,
      loading_login: false,
      validation: {},
    }
  }

  componentDidMount() {

  }

  renderPracticeInfoSection = () => {
    let loading  = this.state.loading_practice;
    let practice = this.props.instant && this.props.instant.instantUserPractice         ? this.props.instant.instantUserPractice         : {};
    let location = this.props.instant && this.props.instant.instantUserPracticeLocation ? this.props.instant.instantUserPracticeLocation : {};

    if (!this.state.display_edit_practice) {
      return <div className='flex-container-column' style={{ padding: 15, paddingTop: 10, paddingLeft: 20, fontSize: 14 }}>
        <div style={{ fontSize: 15, color: '#575757' }}>{ practice.name }</div>
        <div style={{ color: 'grey' }}>{ location.street_address }</div>
        <div className='flex-container-row'>
          <span style={{ color: 'grey', marginRight: 5 }}>{ location.city + ', ' }</span>
          <span style={{ color: 'grey', marginRight: 5 }}>{ location.state   }</span>
          <span style={{ color: 'grey', marginRight: 5 }}>{ location.zipcode }</span>
        </div>
      </div>
    }

    return <div className='flex-container-column' style={{ paddingBottom: 15, paddingTop: 5 }}>
      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 10 }}>
        <Input placeholder="Practice Name"
               value={this.state.practice_name}
               className='instant-input-default'
               invalid={!this.state.practice_name}
               style={{ width: 180 }}
               onChange={ (event) => { this.setState({ ...this.state, practice_name: event.target.value }) }}
              />
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="Street Address"
               value={this.state.street_address}
               className='instant-input-default'
               invalid={!this.state.street_address}
               style={{ flex: 1 }}
               onChange={ (event) => { this.setState({ ...this.state, street_address: event.target.value }) }}
              />
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="City"
               value={this.state.city}
               className='instant-input-default'
               invalid={!this.state.city}
               style={{ width: 180, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, city: event.target.value }) }}
              />
        <Input placeholder="State"
               value={this.state.state}
               className='instant-input-default'
               invalid={!this.state.state}
               style={{ width: 80, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, state: event.target.value }) }}
              />
        <Input placeholder="Zipcode"
               value={this.state.zipcode}
               className='instant-input-default'
               invalid={!this.state.zipcode}
               style={{ width: 100 }}
               onChange={ (event) => { this.setState({ ...this.state, zipcode: event.target.value }) }}
              />
      </div>

      <div style={{ paddingLeft: 15, paddingTop: 5 }}>
        <PhoneInput value={this.state.phone_number}
                    style={{ fontSize: 13 }}
                    containerStyle={{ width: 265 }}
                    invalid={!this.state.phone_number}
                    onChange={ (phone_number) => { this.setState({ ...this.state, phone_number: phone_number }) }} />
      </div>

      <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 15, paddingRight: 15, fontSize: 13 }}>
        <div className='instant-cancel-button'
             style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
             onClick={ () => { this.setState({ ...this.state, display_edit_practice: false, loading_practice: false }) }}>
          <span>Cancel</span>
        </div>
        <div className='instant-join-session-button'
             style={{ fontSize: 13 }}
             onClick={ () => {
               this.processPracticeChanges();
             }}>
          { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white' }} />
                    : <span className='fas fa-check' style={{ fontSize: 16 }} /> }
          <span style={{ marginLeft: 8 }}>Save Changes</span>
        </div>
      </div>

    </div>

  }

  renderLoginInfoSection = () => {
    let loading = this.state.loading_login;
    let user    = this.props.user && this.props.user.user ? this.props.user.user : {};
    let email   = user.email || '';
    let is_edit = this.state.display_edit_email || this.state.display_edit_password;

    if (!is_edit) {
      return <div className='flex-container-column' style={{ padding: 15, paddingTop: 10, paddingLeft: 20, fontSize: 14 }}>
        <div style={{ fontSize: 15, color: '#575757' }}>Edit your login email or password</div>
        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
          <span style={{ color: 'grey' }}>{ email }</span>
          <div className='instant-cancel-button'
               style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
               onClick={ () => { this.setState({ ...this.state, display_edit_email: true }) }}>
            <span className='fas fa-edit' />
          </div>
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
          <span style={{ color: 'grey' }}>{ 'Password' }</span>
          <div className='instant-cancel-button'
               style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
               onClick={ () => { this.setState({ ...this.state, display_edit_password: true }) }}>
            <span className='fas fa-edit' />
          </div>
        </div>
      </div>
    }

    return <div className='flex-container-column' style={{ paddingBottom: 15, paddingTop: 5 }}>

    { this.state.display_edit_email
    ? <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 10 }}>
        <Input placeholder="New Email"
               value={this.state.email}
               className='instant-input-default'
               invalid={this.state.email_invalid}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
              />
        <Input placeholder="Confirm Email"
               value={this.state.confirm_email}
               className='instant-input-default'
               invalid={this.state.confirm_email_invalid}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_email: event.target.value }) }}
              />
      </div> : null }

      { this.state.display_edit_password
      ? <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="New Password"
               value={this.state.password}
               className='instant-input-default'
               invalid={this.state.password_invalid}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
               type='password'
              />
        <Input placeholder="Confirm Password"
               value={this.state.confirm_password}
               className='instant-input-default'
               invalid={this.state.confirm_password_invalid}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_password: event.target.value }) }}
               type='password'
              />
      </div> : null }
      { this.state.display_password_rules && this.state.display_edit_password
        ? <span style={{ fontSize: 12, marginTop: 5, marginLeft: 17, color: 'grey' }}>8 chars or more & containing one of each: a-z A-Z 0-9 @$!%*?&</span> : null }

      <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 15, paddingRight: 15, fontSize: 13 }}>
        <div className='instant-cancel-button'
             style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
             onClick={ () => { this.cancelLoginChanges() }}>
          <span>Cancel</span>
        </div>
        <div className='instant-join-session-button'
             style={{ fontSize: 13 }}
             onClick={ () => {
               let process_email = this.state.password === '' && this.state.email !== '';
               let process_pswd  = this.state.email    === '';
               if (process_email) {
                 this.processEmailChange();
               }
               if (process_pswd) {
                 this.processPasswordChange();
               }

             }}>
          { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white' }} />
                    : <span className='fas fa-check' style={{ fontSize: 16 }} /> }
          <span style={{ marginLeft: 8 }}>Save Changes</span>
        </div>
      </div>

    </div>
  }

  renderContentContainers = () => {

    let practice_header_button_title = this.state.display_edit_practice ? '' : 'Edit';

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column flex-container-column" style={{ alignItems: 'flex-end' }}>
        <div className='instant-settings-container' style={{ marginTop: 15, marginRight: 5 }}>
          <Header title='Practice Info' button_title={practice_header_button_title} button_action={ () => { this.startEditingPractice() }} />
          { this.renderPracticeInfoSection() }
        </div>
      </div>
      <div className="screen-container-column">
        <div className='instant-settings-container' style={{ marginTop: 15, marginLeft: 5 }}>
          <Header title='Login Info' />
          { this.renderLoginInfoSection() }
        </div>
      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <AuthCheck user={this.props.user} userActions={this.props.userActions} />
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar currentRoute={routes.INSTANT_SETTINGS} practice={this.props.practice.practice} />
        { this.renderContentContainers() }
      </div>
    );
  }

  processPasswordChange = () => {
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let user  = this.props.user && this.props.user.user ? this.props.user.user : {};
    let email = user.email || '';

    let new_password = this.state.password;
    let confirm_pwd  = this.state.confirm_password;

    let password_validation = ValidatorUtils.validatePassword(new_password, confirm_pwd);

    if (password_validation.message !== '') {
      this.props.toastActions.displayError(password_validation.message);
      this.setState({ ...this.state, display_password_rules: password_validation.strength_error, password_invalid: password_validation.password_invalid, confirm_password_invalid: password_validation.confirm_password_invalid })
    }

    if (token && email && new_password) {
      this.setState({ ...this.state, loading_login: true })
      this.props.userActions.changeUserPassword(token, email, new_password, this.emailCallback);
    }
  }

  processEmailChange = () => {
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let user  = this.props.user && this.props.user.user ? this.props.user.user : {};
    let email = user.email || '';

    let new_email = this.state.email;

    if (!new_email || !this.state.confirm_email) {
      this.setState({ ...this.state, email_invalid: new_email === '', confirm_email_invalid: this.state.confirm_email === '' })
    }

    if (new_email !== this.state.confirm_email) {
      this.props.toastActions.displayError('Email and Confirm Email do not match')
      this.setState({ ...this.state, email_invalid: false, confirm_email_invalid: true })
    }

    if (token && user && new_email && new_email === this.state.confirm_email) {
      let user_data = {
        _id: user._id,
        email: new_email
      }
      this.setState({ ...this.state, loading_login: true })
      this.props.userActions.editUser(token, user_data, this.emailCallback);
    }
  }

  emailCallback = () => {
    this.setState({
      ...this.state,
      email: '',
      confirm_email: '',
      confirm_email_invalid: false,
      email_invalid: false,
      display_edit_email: false,
      display_edit_password: false,
      password_invalid: false,
      confirm_password_invalid: false,
      display_password_rules: false,
      loading_login: false,
      display_password_rules: false,
      password: '',
      confirm_password: '',
    })
  }

  processPracticeChanges = () => {
    let practice_changed = false;
    let location_changed = false;

    let token    = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';

    let practice = this.props.instant && this.props.instant.instantUserPractice         ? this.props.instant.instantUserPractice         : {};
    let location = this.props.instant && this.props.instant.instantUserPracticeLocation ? this.props.instant.instantUserPracticeLocation : {};

    let old_practice_name = practice  && practice.name;
    practice_changed      = old_practice_name === this.state.practice_name ? false : true;

    location_changed = location.street_address !== this.state.street_address ? true : location_changed;
    location_changed = location.city           !== this.state.city           ? true : location_changed;
    location_changed = location.state          !== this.state.state          ? true : location_changed;
    location_changed = location.zipcode        !== this.state.zipcode        ? true : location_changed;
    location_changed = location.phone          !== this.state.phone_number   ? true : location_changed;

    if (token && practice_changed) {
      let practice_data = {
        _id: practice._id,
        name: this.state.practice_name
      }
      this.props.practiceActions.editPracticeInfo(token, practice_data, this.practiceSaveSuccess);
    }

    if (token && location_changed) {
      let location_data = {
        _id: location._id,
        street_address: this.state.street_address || location.street_address,
        city: this.state.city || location.city,
        state: this.state.state || location.state,
        zipcode: this.state.zipcode || location.zipcode,
        phone: this.state.phone_number || location.phone,
      }
      this.props.practiceActions.editPracticeLocation(token, location_data, this.practiceSaveSuccess, practice_changed);
    }

    if (location_changed || practice_changed) {
      this.setState({ ...this.state, loading_practice: true });
    } else {
      this.practiceSaveSuccess();
    }
  }

  practiceSaveSuccess = () => {
    let token    = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let practice = this.props.instant && this.props.instant.instantUserPractice         ? this.props.instant.instantUserPractice         : {};

    if (token && practice) {
      this.props.instantActions.getInstantPracticeInfo(token, practice._id);
    }

    this.setState({
      ...this.state,
      display_edit_practice: false,
      loading_practice: false,
    })
  }

  startEditingPractice = () => {
    let practice = this.props.instant && this.props.instant.instantUserPractice         ? this.props.instant.instantUserPractice         : {};
    let location = this.props.instant && this.props.instant.instantUserPracticeLocation ? this.props.instant.instantUserPracticeLocation : {};

    this.setState({
      ...this.state,
      display_edit_practice: true,
      practice_name: practice.name,
      street_address: location.street_address,
      city: location.city,
      state: location.state,
      zipcode: location.zipcode,
      phone_number: location.phone,
    });
  }

  cancelLoginChanges = () => {
    this.setState({
      ...this.state,
      email: '',
      confirm_email: '',
      password: '',
      confirm_password: '',
      email_invalid: '',
      confirm_email_invalid: '',
      password_invalid: '',
      confirm_password_invalid: '',
      display_edit_email: false,
      display_edit_password: false,
      loading_login: false,
      display_password_rules: false,
    })
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    instant: state.instant,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantSettingsScreen)
